var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceBox7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 397,
    height: 308,
    viewBox: "0 0 397 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1039_12231)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1039_12231)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 389,
    height: 300,
    rx: 4,
    fill: "#D3EBFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-27.5205 -105C-14.4341 -90.7928 28.2448 -50.5925 84.4933 -60.3341C115.27 -65.6711 159.451 -50.3865 173.854 -14.6701C173.854 -14.6701 188.292 55.7993 263.533 41.0767C295.031 34.9149 326.148 51.8294 348.476 80.84C358.302 93.5975 376.494 115.962 374.059 130.494C373.009 136.771 367.713 140.602 363.565 144.943C352.014 157.08 346.395 177.918 357.142 197.234C367.024 214.979 391.951 221.197 404.521 236.864C463.658 310.563 375.426 331.265 354.689 335.03",
    stroke: "#174997",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeDasharray: "11.32 11.32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-368.521 -105C-355.434 -90.7928 -312.755 -50.5925 -256.507 -60.3341C-225.73 -65.6711 -181.549 -50.3865 -167.146 -14.6701C-167.146 -14.6701 -152.708 55.7993 -77.4665 41.0767C-45.9692 34.9149 -14.8518 51.8294 7.47638 80.84C17.3021 93.5975 35.4937 115.962 33.0595 130.494C32.0085 136.771 26.7129 140.602 22.5649 144.943C11.0136 157.08 5.3947 177.918 16.1423 197.234C26.0242 214.979 50.9514 221.197 63.5208 236.864C122.658 310.563 34.4258 331.265 13.6889 335.03",
    stroke: "#174997",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeDasharray: "11.32 11.32"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1039_12231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M262.856 90.2059C262.856 90.2059 264.778 84.6742 270.544 84.4878C276.31 84.3635 274.264 87.9062 280.278 87.3468C286.354 86.7874 284.122 79.9506 293.546 78.521C302.97 77.0915 307 90.2059 307 90.2059H262.856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.037 23.8264C163.037 23.8264 164.463 19.6621 168.741 19.6C173.019 19.4757 171.469 22.1483 175.995 21.7132C180.521 21.2781 178.847 16.1815 185.915 15.1249C192.983 14.0683 195.959 23.8264 195.959 23.8264H163.037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 65.6555C36 65.6555 37.302 61.9263 41.146 61.8641C44.9899 61.7398 43.6259 64.1638 47.6559 63.7909C51.6859 63.418 50.1979 58.8808 56.5218 57.8863C62.8458 56.954 65.5118 65.6555 65.5118 65.6555H36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.358 283.752H97.4423C87.7084 283.752 79.7725 275.859 79.7725 266.039V59.3163C79.7725 49.5582 87.6464 41.6025 97.4423 41.6025H185.358C195.092 41.6025 203.028 49.496 203.028 59.3163V266.101C203.028 275.859 195.092 283.752 185.358 283.752Z",
    fill: "#E5EDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.358 47.6939C191.744 47.6939 196.952 52.9148 196.952 59.3166V266.101C196.952 272.503 191.744 277.724 185.358 277.724H97.4423C91.0564 277.724 85.8484 272.503 85.8484 266.101V59.3166C85.8484 52.9148 91.0564 47.6939 97.4423 47.6939H185.358ZM185.358 41.665H97.4423C87.7084 41.665 79.7725 49.5585 79.7725 59.3788V266.101C79.7725 275.859 87.6464 283.815 97.4423 283.815H185.358C195.092 283.815 203.028 275.921 203.028 266.101V59.3166C203.028 49.5585 195.092 41.665 185.358 41.665Z",
    fill: "#060000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.928 42.2861H113.935V48.6879C113.935 51.547 116.229 53.8467 119.081 53.8467H163.844C166.696 53.8467 168.99 51.547 168.99 48.6879V42.2861H168.928Z",
    fill: "#060000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.17 47.0723H152.25",
    stroke: "white",
    strokeWidth: 0.764,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.347 257.15H100.542C97.8135 257.15 95.6436 254.975 95.6436 252.24V199.658C95.6436 196.923 97.8135 194.748 100.542 194.748H163.347C166.075 194.748 168.245 196.923 168.245 199.658V252.24C168.245 254.975 166.075 257.15 163.347 257.15Z",
    fill: "#9BBDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.179 221.847H107.733C106.679 221.847 105.749 220.977 105.749 219.858V205.377C105.749 204.32 106.617 203.388 107.733 203.388H122.179C123.233 203.388 124.163 204.258 124.163 205.377V219.858C124.163 220.977 123.233 221.847 122.179 221.847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.425 209.23H146.979",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.425 215.197H157.147",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.811 229.492H124.162",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.811 235.583H157.146",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.811 242.357H157.146",
    stroke: "white",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3778 104.95C70.2613 97.0368 65.3892 89.0911 57.4955 87.2029C49.6018 85.3147 41.6758 90.1989 39.7923 98.1122C37.9087 106.025 42.7809 113.971 50.6746 115.859C58.5682 117.748 66.4942 112.863 68.3778 104.95Z",
    fill: "#DC761C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1523 102.264L52.8023 105.682L60.6763 97.416",
    stroke: "white",
    strokeWidth: 2.1361,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.578 181.448H62.2884C60.4904 181.448 59.0645 180.018 59.0645 178.216V143.783C59.0645 141.98 60.4904 140.551 62.2884 140.551H111.578C113.376 140.551 114.802 141.98 114.802 143.783V178.216C114.802 180.018 113.376 181.448 111.578 181.448Z",
    fill: "#4479FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.52 157.705C95.52 152.857 91.552 148.879 86.716 148.879C81.8801 148.879 77.9121 152.857 77.9121 157.705C77.9121 159.321 78.3461 160.875 79.1521 162.18V162.242C79.4621 162.801 79.8961 163.361 80.3301 163.796L86.716 172.249L93.102 163.796C93.536 163.299 93.97 162.801 94.28 162.18C95.086 160.875 95.52 159.321 95.52 157.705ZM86.716 161.558C84.6081 161.558 82.8721 159.818 82.8721 157.705C82.8721 155.591 84.6081 153.851 86.716 153.851C88.824 153.851 90.56 155.591 90.56 157.705C90.622 159.818 88.886 161.558 86.716 161.558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.87 134.584H98.9302C96.2022 134.584 94.0322 132.408 94.0322 129.674V77.0918C94.0322 74.357 96.2022 72.1816 98.9302 72.1816H183.87C186.598 72.1816 188.768 74.357 188.768 77.0918V129.674C188.768 132.408 186.598 134.584 183.87 134.584Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.166 103.134H103.518C102.588 103.134 101.782 102.389 101.782 101.394V88.7149C101.782 87.7826 102.526 86.9746 103.518 86.9746H116.166C117.096 86.9746 117.902 87.7204 117.902 88.7149V101.394C117.84 102.389 117.096 103.134 116.166 103.134Z",
    fill: "#9BBDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.626 103.134H123.978C123.048 103.134 122.242 102.389 122.242 101.394V88.7149C122.242 87.7826 122.986 86.9746 123.978 86.9746H136.626C137.556 86.9746 138.362 87.7204 138.362 88.7149V101.394C138.362 102.389 137.618 103.134 136.626 103.134Z",
    fill: "#9BBDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.148 103.134H144.5C143.57 103.134 142.764 102.389 142.764 101.394V88.7149C142.764 87.7826 143.508 86.9746 144.5 86.9746H157.148C158.078 86.9746 158.884 87.7204 158.884 88.7149V101.394C158.822 102.389 158.078 103.134 157.148 103.134Z",
    fill: "#9BBDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.608 103.134H164.96C164.03 103.134 163.224 102.389 163.224 101.394V88.7149C163.224 87.7826 163.968 86.9746 164.96 86.9746H177.608C178.538 86.9746 179.344 87.7204 179.344 88.7149V101.394C179.344 102.389 178.6 103.134 177.608 103.134Z",
    fill: "#DC761C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.166 124.888H103.518C102.588 124.888 101.782 124.143 101.782 123.148V110.469C101.782 109.537 102.526 108.729 103.518 108.729H116.166C117.096 108.729 117.902 109.474 117.902 110.469V123.148C117.84 124.143 117.096 124.888 116.166 124.888Z",
    fill: "#9BBDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.626 124.888H123.978C123.048 124.888 122.242 124.143 122.242 123.148V110.469C122.242 109.537 122.986 108.729 123.978 108.729H136.626C137.556 108.729 138.362 109.474 138.362 110.469V123.148C138.362 124.143 137.618 124.888 136.626 124.888Z",
    fill: "#9BBDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.148 124.888H144.5C143.57 124.888 142.764 124.143 142.764 123.148V110.469C142.764 109.537 143.508 108.729 144.5 108.729H157.148C158.078 108.729 158.884 109.474 158.884 110.469V123.148C158.822 124.143 158.078 124.888 157.148 124.888Z",
    fill: "#9BBDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.608 124.888H164.96C164.03 124.888 163.224 124.143 163.224 123.148V110.469C163.224 109.537 163.968 108.729 164.96 108.729H177.608C178.538 108.729 179.344 109.474 179.344 110.469V123.148C179.344 124.143 178.6 124.888 177.608 124.888Z",
    fill: "#9BBDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.543 181.448H129.992C128.194 181.448 126.768 180.018 126.768 178.216V143.783C126.768 141.98 128.194 140.551 129.992 140.551H185.543C187.341 140.551 188.767 141.98 188.767 143.783V178.216C188.767 180.018 187.341 181.448 185.543 181.448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.335 154.535H136.254C135.324 154.535 134.518 153.789 134.518 152.795V146.952C134.518 146.02 135.262 145.212 136.254 145.212H180.335C181.265 145.212 182.071 145.958 182.071 146.952V152.795C182.071 153.789 181.265 154.535 180.335 154.535Z",
    fill: "#9BBDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.199 160.626H156.837",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.199 165.909H181.451",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.199 171.751H181.451",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.365 243.85H183.126C180.956 243.85 179.22 242.11 179.22 239.934V211.903C179.22 209.728 180.956 207.987 183.126 207.987H215.365C217.535 207.987 219.271 209.728 219.271 211.903V239.934C219.271 242.11 217.535 243.85 215.365 243.85Z",
    fill: "#DC761C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.181 224.396L205.879 224.147C205.755 223.588 205.507 223.028 205.197 222.531L205.941 221.412C206.251 221.039 206.189 220.48 205.817 220.107L205.011 219.299C204.639 218.988 204.143 218.926 203.709 219.237L202.593 219.983C202.097 219.672 201.539 219.486 200.981 219.299L200.733 217.932C200.671 217.434 200.237 217.124 199.741 217.062H198.625C198.129 217.062 197.695 217.434 197.633 217.932L197.385 219.237C196.827 219.361 196.269 219.61 195.773 219.921L194.657 219.175C194.285 218.864 193.727 218.926 193.355 219.299L192.549 220.107C192.177 220.48 192.177 220.977 192.425 221.412L193.169 222.531C192.859 223.028 192.673 223.588 192.487 224.147L191.185 224.396C190.689 224.458 190.317 224.893 190.317 225.39V226.509C190.317 227.006 190.689 227.441 191.185 227.503L192.487 227.752C192.611 228.311 192.859 228.871 193.169 229.368L192.425 230.487C192.115 230.86 192.177 231.419 192.549 231.792L193.355 232.6C193.727 232.973 194.223 232.973 194.657 232.724L195.773 231.978C196.269 232.289 196.827 232.476 197.385 232.662L197.633 233.967C197.695 234.464 198.129 234.837 198.625 234.837H199.741C200.237 234.837 200.671 234.464 200.733 233.967L200.981 232.662C201.539 232.538 202.097 232.289 202.593 231.978L203.647 232.724C204.019 233.035 204.577 232.973 204.949 232.6L205.755 231.792C206.127 231.419 206.127 230.922 205.879 230.487L205.135 229.368C205.445 228.871 205.631 228.311 205.817 227.752L207.119 227.503C207.615 227.441 207.987 227.006 207.987 226.509V225.39C208.049 224.893 207.677 224.458 207.181 224.396ZM199.245 229.43C197.323 229.43 195.773 227.876 195.773 225.949C195.773 224.023 197.323 222.469 199.245 222.469C201.167 222.469 202.717 224.023 202.717 225.949C202.717 227.876 201.167 229.43 199.245 229.43Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1143 283.752H299.312",
    stroke: "black",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M289.022 267.361L288.848 277.616L286.513 283.826H299.172L298.451 267.087L289.022 267.361Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.386 268.443V276.943L260.41 283.826H280.486L279.281 267.497L270.386 268.443Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.707 276.519L270.053 277.381L273.058 279.672L273.712 278.811L270.707 276.519Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.22 185.021L287.17 185.22L285.381 192.289L281.48 207.696C280.934 210.148 280.524 212.799 280.225 215.574C278.325 233.11 280.785 255.512 282.064 265.182C282.4 267.721 280.424 269.961 277.865 269.961H270.759C269.132 269.961 267.641 269.016 266.933 267.547C257.888 248.567 259.354 220.217 261.168 213.272C264.038 202.295 266.013 185.917 266.013 185.917L272.039 185.655L287.22 185.021Z",
    fill: "#3A6BEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.811 265.009C300.748 267.448 298.761 269.402 296.326 269.402H290.251C288.002 269.402 286.101 267.734 285.816 265.494C284.66 256.645 281.828 234.331 280.238 215.575C279.405 205.743 278.908 196.882 279.169 191.468C279.256 189.415 279.467 187.846 279.803 186.913L287.182 185.22L294.698 183.503C294.698 183.503 296.562 185.494 298.276 196.11C300.053 207.187 301.668 227.647 300.811 265.009Z",
    fill: "#3A6BEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.456 230.572C279.12 223.653 279.332 217.766 280.102 212.551C280.35 210.871 281.232 209.353 282.586 208.27L287.643 204.25L287.978 204.673L282.922 208.693C281.68 209.689 280.86 211.083 280.636 212.626C279.866 217.803 279.667 223.665 279.99 230.547L279.456 230.572Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.312 232.812L264.25 232.277C267.629 231.854 270.536 231.791 273.12 232.103L273.058 232.638C270.511 232.327 267.654 232.389 264.312 232.812Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.562 231.542L288.5 231.007C291.879 230.584 294.786 230.522 297.37 230.833L297.308 231.368C294.761 231.07 291.904 231.132 288.562 231.542Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.678 263.552C269.069 263.552 265.652 262.73 265.603 262.718L265.727 262.195C265.801 262.22 273.653 264.099 281.579 262.083L281.715 262.606C278.92 263.328 276.125 263.552 273.678 263.552Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.661 263.591C291.928 263.591 291.245 263.566 290.611 263.541C287.63 263.379 285.356 262.944 285.344 262.944L285.443 262.408C285.53 262.421 294.4 264.114 300.301 261.936L300.488 262.446C298.053 263.342 295.133 263.591 292.661 263.591Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.265 196.11C294.836 194.281 290.09 193.073 285.382 192.289C283.27 191.928 281.146 191.667 279.146 191.468C272.835 190.821 267.778 190.821 267.778 190.821L272.052 185.656L287.221 185.009L287.171 185.208L294.687 183.49C294.687 183.515 296.551 185.506 298.265 196.11Z",
    fill: "#1F3C88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.928 144.387H271.691V154.816H277.928V144.387Z",
    fill: "#E28B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.611 148.731C274.611 148.731 273.977 151.008 271.691 152.564V148.009L274.611 148.731Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.475 139.072L268.027 143.453C268.027 143.453 265.99 146.191 267.257 146.191C268.624 146.191 268.412 146.739 268.412 146.739C268.412 146.739 267.642 152.439 274.599 148.718L276.078 140.155L268.475 139.072Z",
    fill: "#E28B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.473 139.072C268.473 139.072 270.361 138.823 270.858 140.827C271.355 142.831 272.013 144.063 273.678 142.669L275.517 139.657L272.374 138.338L268.473 139.072Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.473 139.072C268.473 137.641 270.162 134.244 275.479 135.152C280.56 136.023 281.368 143.167 278.734 146.428C278.734 146.428 277.393 148.544 275.591 144.673L272.498 140.504L271.839 139.184L268.473 139.072Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.867 144.412C275.37 145.283 274.339 145.632 273.581 145.196C272.823 144.761 272.612 143.69 273.121 142.819C273.618 141.948 274.649 141.6 275.407 142.035C276.165 142.471 276.376 143.529 275.867 144.412Z",
    fill: "#E28B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.68 152.539C299.631 156.41 309.061 172.601 298.004 172.875C286.96 173.149 280.214 162.881 280.214 162.881L287.68 152.539Z",
    fill: "#E49B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.807 164.897C234.807 164.897 228.906 162.321 228.707 162.894C228.509 163.466 229.9 164.188 229.9 164.188C229.9 164.188 226.098 163.64 225.788 164.213C225.477 164.785 227.067 164.922 227.067 164.922C227.067 164.922 225.44 164.835 225.279 165.358C225.117 165.88 226.409 166.105 226.409 166.105C226.409 166.105 225.092 166.005 225.005 166.59C224.918 167.175 225.949 167.349 225.949 167.349C225.949 167.349 225.129 167.225 225.328 167.922C225.527 168.619 233.341 170.037 233.341 170.037L236.062 167.349L234.807 164.897Z",
    fill: "#E28B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.805 188.668L267.132 191.581C264.884 191.83 262.933 190.025 263.008 187.76L263.343 176.733L263.505 171.655V171.531C263.505 171.531 263.306 171.767 262.921 172.128C262.921 172.128 262.921 172.128 262.909 172.141C262.66 172.377 262.325 172.663 261.902 172.975C258.362 175.65 248.92 180.255 233.316 170.05L234.795 164.91L251.641 165.607C251.641 165.607 259.194 159.496 265.89 155.302C270.276 152.564 275.344 151.045 280.512 151.182C282.848 151.245 285.357 151.618 287.668 152.564C293.358 154.916 296.178 175.937 297.097 184.586C297.333 186.602 295.855 188.444 293.805 188.668Z",
    fill: "#FBC343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.79 170.56C249.305 167.212 251.392 165.457 251.479 165.383L251.815 165.806C251.815 165.806 251.318 166.217 250.895 167.001C250.324 168.046 250.138 169.216 250.324 170.485L249.79 170.56Z",
    fill: "#E49B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.891 169.639C265.891 169.639 265.729 173.995 263.344 176.733L263.505 171.655C264.4 170.933 265.418 170.087 265.891 169.639Z",
    fill: "#E49B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.001 175.439L257.89 174.903C261.791 174.119 267.046 167.573 267.095 167.511L267.518 167.847C267.505 167.859 266.151 169.552 264.325 171.319C261.853 173.709 259.728 175.09 258.001 175.439Z",
    fill: "#E49B31"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1039_12231",
    x: 0,
    y: 0,
    width: 397,
    height: 308,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1039_12231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1039_12231",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1039_12231"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 389,
    height: 300,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1039_12231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 271,
    height: 269,
    fill: "white",
    transform: "translate(36 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceBox7);
export default __webpack_public_path__ + "static/media/ServiceBox7.b2b0dc2e38165f74b5d049f7106dad76.svg";
export { ForwardRef as ReactComponent };